// extracted by mini-css-extract-plugin
export var heroImage = "_li-1";
export var modal = "_li-0";